import React from "react";
import Button from "../button";

interface PopupComponentProps {
	updatepopup: boolean;
	itemidpopup: string;
	divisionpopup: string;
	reason: string;
	setReason: React.Dispatch<React.SetStateAction<string>>;
	closePopUp: () => void;
	handleSave: () => void;
}

const PopupComponent: React.FC<PopupComponentProps> = ({
	updatepopup,
	itemidpopup,
	divisionpopup,
	reason,
	setReason,
	closePopUp,
	handleSave,
}) => {
	if (!updatepopup) return null;

	return (
		<div className="modalBCI">
			<div className="modalBCI-content">
				<span className="closeBCI" onClick={closePopUp}>
					&times;
				</span>
				<div className="flex items-center justify-center mt-[4vh] mb-[2vh]">
					<span className="font-semibold text-base">
						Type your Reason
					</span>
				</div>
				<table className="w-full border-collapse">
					<tbody>
						<tr className="bg-white">
							<th className="border-r border-gray-c4 px-4 py-3 text-left font-medium">
								Item Id
							</th>
							<th className="border-r border-gray-c4 px-4 py-3 text-left font-medium">
								Division
							</th>
							<th className="px-4 py-3 text-left font-medium">
								Reason
							</th>
						</tr>
						<tr className="bg-white">
							<td className="px-4 py-3">{itemidpopup}</td>
							<td className="px-4 py-3">{divisionpopup}</td>
							<td className="px-4 py-3">
								<input
									type="text"
									value={reason}
									onChange={(e) => setReason(e.target.value)}
									className="border border-gray-c4 rounded-sm bg-muted px-3 py-2 w-full"
								/>
							</td>
						</tr>
					</tbody>
				</table>
				<div className="divModal flex justify-end mt-2">
					<Button
						label="Cancel"
						bgColor="#FF4433"
						size="md"
						className="ml-2 h-[5vh]"
						onClick={closePopUp}
					/>
					<Button
						label="Save"
						bgColor="#86BC25"
						size="md"
						className="ml-2 h-[5vh]"
						onClick={handleSave}
					/>
				</div>
			</div>
		</div>
	);
};

export default PopupComponent;
